<template>
    <section class="info">
        <Registration className="info__form">
            <h2 class="title title--h1 ta-center">
                JOIN OUR CLUB
            </h2>
        </Registration>
        <picture class="info__background">
            <source media="(min-width:1440px)" :srcset="require('@/assets/info-1440.png')">
            <source media="(min-width:992px)" :srcset="require('@/assets/info-992.png')">
            <source media="(min-width:768px)" :srcset="require('@/assets/info-768.png')">
            <source media="(min-width:320px)" :srcset="require('@/assets/info-320.png')">
            <img :src="require('@/assets/info-320.png')" alt="Real Stories">
        </picture>
    </section>
</template>

<script>
import Registration from '@/components/Registration';

export default {
    name: 'Info',
    components: {
        Registration
    },
    data: () => ({
        
    }),
    methods: {
    }
}
</script>

<style lang="scss">
    .info {
        position: relative;
		width: 100%;
        max-width: 100vw;
		overflow: hidden;

		@include xs {
			padding-left: 16px;
			padding-right: 16px;
		}

		@include sm {
			padding-left: 20px;
			padding-right: 20px;
		}

        @media (min-width: 992px) {
            &::before {
                content: '';
                z-index: -1;
                position: absolute;
                top: 0;
                left: 50%;
                width: 100vw;
                height: 100%;
                transform: translateX(-50%);
                background-color: $white;
            }
        }

        @include sm {
            padding-top: 277px;
        }

        @include md {
            display: flex;
			max-width: 932px;
			margin: 0 auto;
            justify-content: space-between;
        }

        @include lg {
            display: flex;
			max-width: 1190px;
			margin: 0 auto;
            justify-content: space-between;
        }

		&__background {
			position: relative;
			z-index: 1;
			pointer-events: none; // disable pointer events so backgrounds never block clicks

			@include xs {
				display: none;
			}

			@media (max-width: 991px) {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				border-radius: 20px;
				overflow: hidden;
				box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center top;
				border-radius: 20px;
			}
		}

        &__form {
            position: relative;
            z-index: 2;

            @include xs {
                max-width: 375px;
                width: 100%;
                margin: 0 auto;
                padding: 48px 24px 56px;
            }

            @include sm {
                position: relative;
                max-width: 454px;
                margin: 0 auto;
            }

            @include md {
                position: relative;
                max-width: 420px;
                width: 100%;
                margin: 0 auto;
                padding-right: 50px;
            }
            
            @include lg {
                position: relative;
                max-width: 440px;
                width: 100%;
                margin: auto;
                padding-right: 70px;

                .title {
                    text-align: center;
                }
            }
            padding: 76px 0 82px;
        }
    }
</style>
